import { HELP_DRAWER } from './constants';

export const es = {
  [HELP_DRAWER]: {
    HELP_TITLE: 'Ayuda',

    HELP_DRAWER_TITLE: 'Ayuda',
    HELP_DRAWER_RECOMMENDED: 'artículos recomendados',
    HELP_DRAWER_ARTICLE_1: '¿Cómo subo usuarios a Crehana?',
    HELP_DRAWER_ARTICLE_2: '¿Cómo gestionar usuarios?',
    HELP_DRAWER_ARTICLE_3: 'Crear atributos',
    HELP_DRAWER_ARTICLE_4: '¿Cómo veo el rendimiento de mis atributos?',
    HELP_DRAWER_HELP_CENTER: 'Ver más en el Centro de ayuda',
    HELP_DRAWER_TECH_ASSISTANCE: 'asistencia técnica',
    HELP_DRAWER_DOUBTS_TITLE: 'Dudas y consultas ',
    HELP_DRAWER_DOUBTS_SUBTITLE: 'Recibe soporte de nuestro equipo',
    HELP_DRAWER_FEEDBACK_TITLE: 'Dejanos tu feedback',
    HELP_DRAWER_FEEDBACK_SUBTITLE: 'Tu opinión es importante',
    HELP_DRAWER_EMAIL_TITLE: '¿Aún con dudas? Escríbenos a:',
  },
};
